import { render, staticRenderFns } from "./DuplicateStep1ProjectDetails.vue?vue&type=template&id=3221541e&scoped=true&"
import script from "./DuplicateStep1ProjectDetails.vue?vue&type=script&lang=js&"
export * from "./DuplicateStep1ProjectDetails.vue?vue&type=script&lang=js&"
import style0 from "./DuplicateStep1ProjectDetails.vue?vue&type=style&index=0&id=3221541e&scoped=true&lang=css&"
import style1 from "./DuplicateStep1ProjectDetails.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3221541e",
  null
  
)

export default component.exports